/**
 * Generates a random string of a given length.
 * @param length The length of the random string to generate.
 * @returns A random string of the specified length.
 */
export function generateRandomString(length: number): string {
  const uint8Array: Uint8Array = new Uint8Array(length);
  const random: Uint8Array = window.crypto.getRandomValues(uint8Array);
  const array: Array<number> = Array.from(random);

  return btoa(String.fromCharCode.apply(null, array)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
